var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C10.3431 2 8.99997 3.34315 8.99997 5H15C15 3.34315 13.6568 2 12 2ZM15 7V8C15 8.55228 15.4477 9 16 9C16.5522 9 17 8.55228 17 8V7H18.2215C18.7286 7 19.1554 7.37955 19.2146 7.88316L20.744 20.8832C20.814 21.4777 20.3495 22 19.7509 22H4.24905C3.65046 22 3.18596 21.4777 3.2559 20.8832L4.78531 7.88316C4.84456 7.37955 5.27138 7 5.77846 7H6.99997V8C6.99997 8.55228 7.44768 9 7.99997 9C8.55225 9 8.99997 8.55228 8.99997 8V7H15ZM6.99997 5H5.77846C4.25721 5 2.97676 6.13864 2.79901 7.64948L1.2696 20.6495C1.05978 22.433 2.45327 24 4.24905 24H19.7509C21.5467 24 22.9402 22.433 22.7303 20.6495L21.2009 7.64948C21.0232 6.13864 19.7427 5 18.2215 5H17C17 2.23858 14.7614 0 12 0C9.23854 0 6.99997 2.23858 6.99997 5Z",
    fill: "#5C6278"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.68966cf1f7e48437317e67081c1e9f58.svg";
export { ForwardRef as ReactComponent };